import { useCallback, useState } from 'react';
import L from 'leaflet';

export function useViewport() {
  let [ zoom, setZoom ] = useState();
  let [ map, setMap ] = useState();
  let [ viewport, setViewport ] = useState();
  let [ bounds, setBounds ] = useState();

  let fitBounds = useCallback(bounds => {
    let formattedBounds = L.latLngBounds(bounds);

    setBounds(formattedBounds);
    if (map) map.fitBounds(formattedBounds);
  }, [map]);

  let onMapInit = useCallback(map => {
    setMap(map);
    setViewport(map.getBounds());
    setZoom(map.getZoom());
  }, []);

  let onViewportEvent = useCallback((event) => {
    setViewport(event.target.getBounds());
    setZoom(event.target.getZoom());
  }, []);

  return {
    zoom,
    map,
    viewport,
    bounds,

    fitBounds,

    onMapInit,
    onViewportEvent,
  };
}
